import React, { useState } from 'react';
import axios from 'axios';
import { safeStorage } from '../utils/safeStorage';

function AdminLogin({ onLogin }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
        password
      });

      // Salva o token no localStorage
      const saved = safeStorage.setItem('adminToken', response.data.token);

      // Configura o token para todas as futuras requisições
      axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

      if (!saved) {
        alert('Login realizado, mas a sessão pode não persistir. Use o modo normal do navegador (não use modo privado).');
      }

      onLogin(true);
    } catch (error) {
      setError('Senha incorreta!');
      console.error('Erro no login:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <h2>Login Administrativo</h2>
      <div className="login-form">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="SENHA DO ADM"
          disabled={loading}
        />
        <button onClick={handleLogin} disabled={loading}>
          {loading ? 'Entrando...' : 'Login'}
        </button>
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
}

export default AdminLogin;
